module.exports = __webpack_public_path__ + "img/9791189015459.bb954946.jpg";